<template>
  <div
    v-if="!isWC()"
    class="headersize introimg text-white position-relative"
    :style="bannerStyles"
  >
    <div
      class="position-absolute w-100 h-100 d-flex justify-content-center align-items-center flex-column bg-opacity"
      v-if="!isRolldStore()"
    >
      <div class="company-details">
        <router-link v-if="getLogo && showLogo" to="/">
          <img :src="getLogo" alt="logo" @error="showLogoError" style="max-width: 220px; padding: 20px 0;"/>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "IntroHeader",
  data() {
    return {
      showLogo: true
    };
  },
  computed: {
    ...mapGetters(["hqDoc"]),
    headAbsolute() {
      if (this.hqDoc && this.hqDoc.ProfileImage != "") {
        return `url(${this.hqDoc.ProfileImage})`;
      } else {
        return "";
      }
    },
    getLogo() {
      if (this.isRolldStore()) {
        return this.hqDoc ? this.hqDoc.Logo : null;
      }
      return null;
    },
    bannerStyles() {
      if (this.isRolldStore()) {
        return {
          'background-image': 'none',
          'min-height': '30px',
        }
      } else {
        return [
          this.headAbsolute != '' ?
            { 'background-image': this.headAbsolute } :
            '',
        ];
      }
    }
  },
  methods: {
    showLogoError() {
      this.showLogo = false;
    }
  }
};
</script>
